// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 4.8 3.85 L 9.33 6.23 C 11.19 7.21 11.19 8.79 9.33 9.77 L 4.8 12.15 C 3.58 12.78 2.6 12.19 2.6 10.82 L 2.6 5.18 C 2.6 3.81 3.58 3.22 4.8 3.85 Z',
  'M13.5 3V13',
];
